var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"heading",class:{ 'bold': _vm.bold, 'white': _vm.isWhite, 'center': _vm.isCenter }},[_c(_vm.level,{tag:"component"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }